module.exports = __webpack_public_path__ + "static/media/contactEmailLogo.cdd43b85.svg";